export default status => {
  if (status === 'NOT_REDEEMED') {
    return '#EBEBEB';
  } if (status === 'PARTIALLY_REDEEMED') {
    return '#FFEDCC';
  } if (status === 'REDEEMED') {
    return '#C9FFEF';
  } return '#EBEBEB';
};
